import { render, staticRenderFns } from "./ComHeader.vue?vue&type=template&id=28f596c8&scoped=true"
import script from "./ComHeader.vue?vue&type=script&lang=js"
export * from "./ComHeader.vue?vue&type=script&lang=js"
import style0 from "./ComHeader.vue?vue&type=style&index=0&id=28f596c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f596c8",
  null
  
)

export default component.exports